<template>
    <div class="questionnaireContainer">
        <div v-if="data">
        <el-form :model="data" ref="ruleForm">
            <div slot="header" class="headerBox"><span>合规问卷</span></div>
            <div class="contentBox">
                <div class="companyBaseInfoBox">
                    <h5>企业基本情况</h5><br>
                    <el-row :gutter="10">
                        <el-col :md="8">公司名称：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.corporateName"
                                    type="text"
                                    placeholder="公司名称">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">统一社会信用代码：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.unifiedSocialCreditCode"
                                    type="text"
                                    placeholder="统一社会信用代码">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">注册地址：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.registeredAddress"
                                    type="text"
                                    placeholder="注册地址">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">实际经营地址：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.actualBusinessAddress"
                                    type="text"
                                    placeholder="实际经营地址">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">公司官网地址：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.companyOfficialWebsiteAddress"
                                    type="text"
                                    placeholder="公司官网地址">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">法定代表人（姓名+联系电话）：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.legalRepresentative"
                                    type="text"
                                    placeholder="法定代表人（姓名+联系电话）">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">总经理（姓名+联系电话）：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.generalManager"
                                    type="text"
                                    placeholder="总经理（姓名+联系电话）">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">销售总监（姓名+联系电话）：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.companyBaseInfo.salesDirector"
                                    type="text"
                                    placeholder="销售总监（姓名+联系电话）">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">其他主要管理人员（请注明职务+姓名+联系电话）：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input type="textarea"
                                    v-model="data.companyBaseInfo.otherKeyManagers"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <hr><br>
                <div class="companyBaseInfoBox">
                    <h5>劳动用工合规</h5><br>
                    <el-row :gutter="10">
                        <el-col :md="8">职工总人数：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input
                                    v-model="data.laborCompliance.totalNumberOfEmployees"
                                    type="text"
                                    placeholder="职工总人数">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">劳动用工中是否有童工：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-radio v-model="data.laborCompliance.childLabourExists" label="1">是</el-radio>
                                <el-radio v-model="data.laborCompliance.childLabourExists" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">是否为所有职工购买了社会保险：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-radio v-model="data.laborCompliance.buyingSocialInsurance" label="1">是</el-radio>
                                <el-radio v-model="data.laborCompliance.buyingSocialInsurance" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">是否违法强制职工加班：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-radio v-model="data.laborCompliance.mandatoryOvertimeWork" label="1">是</el-radio>
                                <el-radio v-model="data.laborCompliance.mandatoryOvertimeWork" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">是否存在剥夺职工合法权利、拖欠工资、侵犯人权等现象：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-radio v-model="data.laborCompliance.deprivationOfStaff" label="1">是</el-radio>
                                <el-radio v-model="data.laborCompliance.deprivationOfStaff" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div><hr><br>
                <div class="companyBaseInfoBox">
                    <h5>公司销售合规</h5><br>
                    <el-row :gutter="10">
                        <el-col :md="8">公司销售区域：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-radio v-model="data.companySalesCompliance.companySalesArea" label="1">大陆地区 </el-radio>
                                <el-radio v-model="data.companySalesCompliance.companySalesArea" label="2">港澳台地区</el-radio>
                                <el-radio v-model="data.companySalesCompliance.companySalesArea" label="3">海外地区</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">销售人员总人数及销售组织架构情况简介：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input type="textarea" 
                                v-model="data.companySalesCompliance.salesBrief"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司是否根据其当地法律进行组织并经营的？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLegal" label="1">是</el-radio>
                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLegal" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司是否有资质及证明能在指定地点进行商业活动？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.companySalesCompliance.isTheCompanyQualified" label="1">是</el-radio>
                                <el-radio v-model="data.companySalesCompliance.isTheCompanyQualified" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司是否已获取所有营销紫光华智产品及服务所需的政府许可、执照和登记？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLicense" label="1">是</el-radio>
                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLicense" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">贵公司是否计划使用次级代理来销售紫光华智的产品和服务？（若是，请在备注栏提供次级渠道商名单）</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.companySalesCompliance.secondaryAgency" label="1">是</el-radio>
                                <el-radio v-model="data.companySalesCompliance.secondaryAgency" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div><hr><br>
                <div class="companyBaseInfoBox">
                    <h5>企业反腐败合规、道德合规</h5><br>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否存在商业贿赂行为？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.moralCompliance.commercialBribery" label="1">是</el-radio>
                                <el-radio v-model="data.moralCompliance.commercialBribery" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否有不廉洁、腐败现象？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.moralCompliance.corruptionPhenomenon" label="1">是</el-radio>
                                <el-radio v-model="data.moralCompliance.corruptionPhenomenon" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司对所有销售紫光华智产品及提供相关服务的公司进行反腐败培训，并对培训予以记录。</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.moralCompliance.antiCorruptionTraining" label="1">是</el-radio>
                                <el-radio v-model="data.moralCompliance.antiCorruptionTraining" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否有操纵市场价格行为？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.moralCompliance.manipulatingMarketPrices" label="1">是</el-radio>
                                <el-radio v-model="data.moralCompliance.manipulatingMarketPrices" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否有不道德商业欺诈行为？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.moralCompliance.commercialFraud" label="1">是</el-radio>
                                <el-radio v-model="data.moralCompliance.commercialFraud" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否有舞弊行为？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.moralCompliance.fraudulentPractices" label="1">是</el-radio>
                                <el-radio v-model="data.moralCompliance.fraudulentPractices" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否有对销售产品不负责任的现象？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.moralCompliance.irresponsiblePhenomena" label="1">是</el-radio>
                                <el-radio v-model="data.moralCompliance.irresponsiblePhenomena" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div><hr><br>
                <div class="companyBaseInfoBox">
                    <h5>企业诚信合规</h5><br>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否申请过破产？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.applyingForBankruptcy" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.applyingForBankruptcy" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否受过或可能会受到行政机关（如工商管理部门或税务部门）行政处分/处罚？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.administrativeSanction" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.administrativeSanction" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司或主要管理人员在最近五年是否受过政府部门调查或制裁？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentSurvey" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentSurvey" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司或主要管理人员最近五年是否被法院纳入失信被执行人名单、受限制被执行人名单？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.discredit" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.discredit" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司或主要管理人员最近五年是否存在或将要被限制进出口？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.restraintOnExportAndImport" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.restraintOnExportAndImport" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司或主要管理人员是否曾经被控告或定罪或处罚或判刑（包括但不限于进出口、贿赂、关税、反垄断竞争、非法经营等）？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.accusedOrConvicted" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.accusedOrConvicted" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司主要管理人员是否曾经或现在在政府部门中担任职务+A17:A41</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentsHoldPositions" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentsHoldPositions" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司主要管理人员是否同时服务于本公司以外的机构？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.serveOrganizationsOthers" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.serveOrganizationsOthers" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否被取消过提供经销及服务的授权或被拒绝更新提供经销或服务授权？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.cancellationOfOfferedDistribution" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.cancellationOfOfferedDistribution" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="20">公司最近五年是否存在已完结的或悬而未决的诉讼、仲裁、行政处罚案件？</el-col>
                        <el-col :md="4">
                            <el-form-item >
                                <el-radio v-model="data.enterpriseCreditCompliance.isThereCase" label="1">是</el-radio>
                                <el-radio v-model="data.enterpriseCreditCompliance.isThereCase" label="2">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div><hr><br>
                <div>
                    <el-row :gutter="10">
                        <el-col :md="8">备注说明：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input type="textarea" 
                                    v-model="data.epilogue.remarks"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">问卷填写日期：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-date-picker
                                    readonly
                                    v-model="data.epilogue.writeDate"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">填写人姓名：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input placeholder="填写人姓名"
                                    v-model="data.epilogue.writer"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">职位：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input placeholder="职位"
                                    v-model="data.epilogue.position"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">联系电话：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input placeholder="联系电话"
                                    v-model="data.epilogue.tel"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :md="8">电子邮箱：</el-col>
                        <el-col :md="16">
                            <el-form-item >
                                <el-input placeholder="电子邮箱"
                                    v-model="data.epilogue.email"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="approveAdviseBox">
                <el-row :gutter="10">
                    <el-col :md="24">
                        <el-form-item label="此处填写您对该渠道认证申请中合规问卷的审批意见：">
                            <el-input type="textarea" placeholder="审批意见" v-model="advise"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="buttonBox">
                <el-row :gutter="10">
                    <el-col :md="23">
                        <el-button type="primary" @click="approveNodeFour(1)">审批通过</el-button>
                        <el-button type="danger" @click="approveNodeFour(-1)">驳回申请</el-button>
                    </el-col>
                    <el-col :md="1">
                        <el-button type="default" @click="gotoApproveHomePage">返回申请信息页</el-button>
                    </el-col>
                </el-row>
            </div>
            <el-dialog title="进程提示框" :visible.sync="processVisible" width="30%">
                <span>正在执行中，请稍候......</span>
             </el-dialog>
        </el-form>
        </div>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                processVisible:false,
                id:'',
                advise:'',
                data:'',
            }
        },
        created(){
            this.getRouterParams();
            this.initQuestionnaire();
        },
        methods:{
            getRouterParams(){
                let _id = this.$route.params.id;
                this.id = _id;
            },
            initQuestionnaire(){
                this.$axios({
                    method:'post',
                    url: '/api/workCommon/getQuestionnaire',
                    withCredentials:true,
                    data: this.$qs.stringify({
                        id:this.id
                    })
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success("获取数据成功");
                        this.data = response.data.data;
                        console.log(this.data)
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    console.log(error)       //请求失败返回的数据
                    this.$message.error(error);
                }).finally(()=>{
                });
            },
            gotoApproveHomePage(){
                this.$router.push({path: '/work/approverHome'});
            },
            approveNodeFour(operate){
                this.processVisible = true;
                this.$axios({
                    method:'post',
                    url:'/api/workApprover/approves',
                    withCredentials:true,
                    data: this.$qs.stringify({
                        id:this.id,
                        operate: operate,
                        advise: this.advise,
                    })
                }).then((response) =>{          //这里使用了ES6的语法
                    console.log(response)
                    if(response.data.code == 1){
                        this.$message.success(`审批成功`);
                        this.gotoApproveHomePage();
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`审批失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                    this.processVisible = false;
                })
            },
        }
    }

</script>
<style type="text/css">
	.questionnaireContainer{
        margin: 0 auto;
        margin-top:30px;
        width:1000px;
        padding:30px 0;
    }
    .buttonBox{
        text-align: center;
        margin: 30px auto;
        margin-top:0;
        width:1000px;
    }
    .approveAdviseBox{
        width:1000px;
        margin: 0 auto;
    }
</style>